import React, { useState, useRef } from 'react';
// Components
import emptyCpayImage from '../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../img/coinera/empty-coinera.svg';
import noCheckoutImgSVG from '../../../img/default-svg/no-checkout-image.svg';
import moreSVG from '../../../img/default-svg/more.svg';
import moreSVGInex from '../../../img/inex/more.svg';
import transactionsSVG from '../../../img/default-svg/checkoutTransactions.svg';
import editSVG from '../../../img/default-svg/edit.svg';
import deleteSVG from '../../../img/default-svg/trash.svg';
import duplicateSVG from '../../../img/default-svg/duplicate.svg';
import Button from '../../Button';
import { Menu, Dropdown, Modal, Row, Col } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import DeletePlan from '../CheckoutsModals/DeletePlan';
// Utils
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Style
import '../CheckoutsList/style.scss';
//icons
import donationIcon from '../../../img/checkout-types/donation.svg';
import p2pIcon from '../../../img/checkout-types/p2p.svg';
import sellIcon from '../../../img/checkout-types/sell.svg';

import { identity } from '../../../utils/getIdentity';
import { AppConfig } from "../../../config";

const checkoutsNoDataSVG = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
};

const { confirm } = Modal;

function showPromiseConfirm(t, name, type, action, merchantId, checkoutId, page) {
  confirm({
    title: `${t('checkouts.deleteTitle')} ${t(type.toLowerCase())}?`,
    icon: <ExclamationCircleOutlined />,
    content: name,
    onOk() {
      return action({ merchantId, checkoutId }, page);
    },
    onCancel() {},
    okText: t('okButton'),
    cancelText: t('cancelButton'),
  });
}

const iconObj = {
  donation: donationIcon,
  sale: sellIcon,
  saletoken: p2pIcon,
  cart: sellIcon,
};

const PlansList = ({
                     data,
                     page,
                     type,
                     fetching,
                     setIsVisible,
                     deleteCheckout,
                     merchantId,
                     openDetailedHandler,
                     openEditHandler,
                     openDuplicateHandler,
                     deletePlan,
                     typeNetwork,
                     getPlansList,
                     supportedCurrencies,
                     openPlanDetails,
                   }) => {
  const [showAddressCopiedPopover, setShowAddressCopiedPopover] = useState(false);
  const [isOpenDeletePlan, setIsOpenDeletePlan] = useState(false);
  const [currency, setCurrency] = useState('');
  const [currentId, setCurrentId] = useState('');
  const { t } = useTranslation();
  const addressCopyPopoverTimer = useRef(null);

  const location = window.location.href;
  const checkoutLinkCPay =
    location.includes('demo') || location.includes('localhost')
      ? 'https://checkouts-geme-wallet-demo.gemewallet.com/'
      : location.includes('stage')
      ? 'https://checkouts-geme-wallet-stage.gemewallet.com/'
      : 'https://checkouts.gemewallet.com/';
  const checkoutLinkNFG = 'https://checkouts.crypto-now.io/';
  const checkoutLinkFinvaro = 'https://checkouts.finvaro.com/';
  const checkoutLinkClarnium = 'https://checkouts.clarnium.io/';
  const checkoutLinkInex = 'https://checkouts.inexlatampay.com/';
  const checkoutLinkInsta = 'https://checkouts.instaxgateway.com/';
  const checkoutLinkCoinera = 'https://checkouts-coin.finera.com/'

  const checkoutLink = {
    cpay: checkoutLinkCPay,
    nfg: checkoutLinkNFG,
    finvaro: checkoutLinkFinvaro,
    clarnium: checkoutLinkClarnium,
    inex: checkoutLinkInex,
    insta: checkoutLinkInsta,
    coinera: checkoutLinkCoinera
  };

  const openPublish = (el, action) => {
    openEditHandler(el, action);
    openPlanDetails();
  }

  // const checkoutSaleLink = {
  //   cpay: 'sell-token-checkout',
  //   nfg: 'sale-token-checkout'
  //  }

  const periodType = {
    0: t('admin.hourly'),
    1: t('admin.daily'),
    2: t('admin.weekly'),
    3: t('admin.monthly'),
    4: t('admin.yearly'),
  };

  const openDeleteModal = id => {
    setIsOpenDeletePlan(true);
    setCurrentId(id);
  };

  const addressCopyHandler = (identifier, type) => {
    navigator.clipboard.writeText(
      `${checkoutLink[identity]}${type === 'saletoken' ? 'sell-token-checkout' : 'checkout'}/${identifier}`
    );
    setShowAddressCopiedPopover(true);
    addressCopyPopoverTimer.current = setTimeout(() => setShowAddressCopiedPopover(false), 1000);
  };

  const removePlan = async () => {
    await deletePlan(page, currentId, merchantId, typeNetwork);

    setIsOpenDeletePlan(false);
    await getPlansList({
      merchantId,
      params: {
        typeNetwork,
        page,
        limit: 5,
        order: 'DESC'
      },
    });
  };

  return (
    <div className="checkouts-list">
      {fetching ? (
        <div>{t('swap.loading')}...</div>
      ) : data && data.length !== 0 ? (
        <div>
          <Row className={`plans plans-${identity}`}>
            <Col span={5}>{t('plans.name')}</Col>
            <Col className="plans__col" span={4}>
              {t('plans.subscribers')}
            </Col>
            <Col className="plans__col" span={3}>
              {t('plans.status')}
            </Col>
            <Col className="plans__col" span={3}>
              {t('plans.period')}
            </Col>
            <Col className="plans__col" span={4}>
              {t('plans.price')}
            </Col>
            <Col className="plans__col" span={4}>
              {t('plans.total')}
            </Col>
          </Row>
          {data.map(el => (
            <div key={el._id} className={`plans__not checkouts-list__plan checkouts-list__plan-${identity}`}>
              <Row className="plans__not checkouts-list__plan__plans">
                <Col
                  className="plans__cursor"
                  span={5}
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                >
                  <div className="checkouts-list__plan__plans--row">
                    <img src={el.image ? `${process.env.REACT_APP_API_URL}${el.image}` : noCheckoutImgSVG} alt="" />
                    <div>
                      <div className={`checkouts-list__checkout-info-name checkouts-list__checkout-info-name-${identity}`}>
                        {el.organizationName || el.productName || el.cartName || el.name}
                      </div>
                      <div className="checkouts-list__checkout-info-description">{el.description}</div>
                    </div>
                  </div>
                </Col>
                <Col
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                  className="plans__col plans__cursor"
                  span={4}
                >
                  <span>
                    {el?.activeSubscriptions}/{el?.subscriptionsTotal}
                  </span>
                </Col>
                <Col
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                  className="plans__col plans__col--dot plans__cursor"
                  span={3}
                >
                  <span
                    className={`checkouts-list__checkout-price--block ${
                      el?.published === false
                        ? 'checkouts-list__checkout-price--block--draft'
                        : el?.published === true && el?.status === false
                          ? 'checkouts-list__checkout-price--block--deactive'
                          : 'checkouts-list__checkout-price--block--active'
                    }`}
                  ></span>
                  <span
                    className={
                      el?.published === false
                        ? 'checkouts-list__checkout-price--draft'
                        : el?.published === true && el?.status === false
                          ? 'checkouts-list__checkout-price--deactive'
                          : 'checkouts-list__checkout-price--active'
                    }
                  >
                    {el?.published === false
                      ? 'Draft'
                      : el?.published === true && el?.status === false
                        ? 'Deactive'
                        : 'Active'}
                  </span>
                </Col>
                <Col
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                  className="plans__col plans__cursor"
                  span={3}
                >
                  <span>{periodType[el?.periodType]}</span>
                </Col>
                <Col
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                  className="plans__col plans__cursor"
                  span={4}
                >
                  <span>
                    {el?.price} {supportedCurrencies?.data?.find(item => item?._id === el?.currency)?.title}
                  </span>
                </Col>
                <Col
                  onClick={() => {
                    openDetailedHandler(el, true);
                  }}
                  className="plans__col plans__cursor"
                  span={4}
                >
                  <span>{el?.totalAmount}$</span>
                </Col>
                <Dropdown
                  placement="bottomLeft"
                  overlay={
                    <Menu className={`menu menu-${identity}`}>
                      {type !== 'plan' && (
                        <Menu.Item key="0">
                          <Link to={`/?checkoutId=${el.identifier}`} className="checkouts-list__checkout-drop-item">
                            <div className="checkouts-list__checkout-drop-item">
                              <img src={transactionsSVG} alt="" />
                              {t('transactions')}
                            </div>
                          </Link>
                        </Menu.Item>
                      )}
                      {type === 'plan' && (
                        <Menu.Item key="0">
                          <Link to={`/subscriptions/?planId=${el._id}`} className="checkouts-list__checkout-drop-item">
                            <div className="checkouts-list__checkout-drop-item">
                              <img src={transactionsSVG} alt="" />
                              {t('subscriptions')}
                            </div>
                          </Link>
                        </Menu.Item>
                      )}
                      <Menu.Item key="0">
                        <Link to={`/activities/?planId=${el._id}`} className="checkouts-list__checkout-drop-item">
                          <div className="checkouts-list__checkout-drop-item">
                            <img src={transactionsSVG} alt="" />
                            {t('activities')}
                          </div>
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="3">
                        <div className="checkouts-list__checkout-drop-item" onClick={() => openDuplicateHandler(el)}>
                          <img src={duplicateSVG} alt="" />
                          {t('duplicate')}
                        </div>
                      </Menu.Item>
                      {!el?.published && (
                        <Menu.Item key="4">
                          <div className="checkouts-list__checkout-drop-item" onClick={() => openPublish(el, 'publish')}>
                            <img src={editSVG} alt="" />
                            {t('public')}
                          </div>
                        </Menu.Item>
                      )}
                      <Menu.Item key="5">
                        <div className="checkouts-list__checkout-drop-item" onClick={() => openEditHandler(el)}>
                          <img src={editSVG} alt="" />
                          {t('edit')}
                        </div>
                      </Menu.Item>
                      <Menu.Item key="6">
                        <div className="checkouts-list__checkout-drop-item" onClick={() => openDeleteModal(el?._id)}>
                          <img src={deleteSVG} alt="" /> {t('delete')}
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                >
                  <div className="checkouts-list__checkout-actions">
                    <img src={identity === "inex" ? moreSVGInex : moreSVG} alt="" />
                  </div>
                </Dropdown>
              </Row>
            </div>
          ))}
        </div>
      ) : (
        <div className="checkouts-list__empty">
          <div className="checkouts-list__empty-text">
            {type === 'plan' ? t('checkouts.noPlans') : t('checkouts.noCheckouts')}
          </div>
          <img src={checkoutsNoDataSVG[identity]} alt="" />
          <Button type="primary" className="checkouts-list__button" onClick={() => setIsVisible(true)}>
            {type === 'plan' ? t('checkouts.createPlan') : t('checkouts.createCheckout')}
          </Button>
        </div>
      )}

      <DeletePlan removePlan={removePlan} visible={isOpenDeletePlan} close={() => setIsOpenDeletePlan(false)} />
    </div>
  );
};

export default PlansList;